import styles from "../item/Item.module.css";
import TemplatePreviewView from "../../template-preview/TemplatePreview.view";
import DraggableView from "../../draggable/Draggable.view";
import { formatStringWithPrefixAndSuffix } from "../../../tools/formatters/StringFormatter";
import { v4 } from "uuid";
import type ItemProperties from "./Item.properties.ts";
import { useEditMarket } from "../../../provider/edit-market/EditMarket.hook.ts";

export default function ItemView(props: ItemProperties) {
  const uuid = v4();
  const { enableDragAndDropToolbar } = useEditMarket();

  return (
    <div className={styles.itemContainer}>
      <table className={styles.tableContainer}>
        <tbody>
          <tr>
            <td className={styles.trLabel}>
              <b>{props.marketComponentType.name}</b>
            </td>
            <td className={styles.trImage} rowSpan={3}>
              <div className={styles.draggableContainer}>
                <DraggableView
                  disabled={!enableDragAndDropToolbar}
                  id={uuid}
                  marketComponentTypeDetails={props.marketComponentType}
                  position="relative"
                >
                  <TemplatePreviewView
                    marketComponentType={props.marketComponentType}
                  />
                </DraggableView>
              </div>
            </td>
          </tr>
          <tr>
            <td className={styles.trValues}>
              <i>
                {formatStringWithPrefixAndSuffix(
                  props.marketComponentType.size?.height,
                  "Tiefe:",
                  "cm",
                )}
              </i>
            </td>
          </tr>
          <tr>
            <td className={styles.trValues}>
              <i>
                {formatStringWithPrefixAndSuffix(
                  props.marketComponentType.size?.width,
                  "Breite:",
                  "cm",
                )}
              </i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
